<template>
  <div class="box7">
    <pageTitle title="一次付出  四大收获" text="【前沿技术、云上实操、理论内容、硬核证书】四大收获<br/>打开职业发展全局视野" titleColor="#332114"
      titColor=" #664c33" />
    <ul class="content">
      <li v-for="(item, index) in list" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="line"></div>
        <div class="img-box" v-if="item.type == 2">
          <div class="img-mask" @click="showFlag = true">
            <img class="small-img" :src="item.img" alt="">
          </div>
          <span>{{ item.tips }}</span>
        </div>
        <div class="info-box" v-else>
          <p v-for="(v1, i1) in item.info" :key="`info-${i1}`" v-html="v1"></p>
          <div v-if="index === 2">......</div>
        </div>
      </li>
    </ul>
    <div class="big-img-mask" v-show="showFlag" @click="showFlag = false">
      <img src="../../../assets/coursePage/acp/box7/card-s.png" alt="" class="check-big">
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      showFlag: false,
      list: [
        {
          title: '前沿技术全掌握',
          type: 1,
          info: [
            `课程项目依托于传智教育数字化建设场景，真实还原实时计算业务和实时数仓场景`,
            `课程从项目背景与架构设计、数据采集、数据下沉到数据可视化，对核心技术技能详细剖析`
          ],
        },
        {
          title: '云上实操 搞定在线实验',
          type: 1,
          info: [
            `手把手带你使用阿里云平台完成数据库、网络、运维等阿里云工作中常见的核心项目操作及配置，亲自云上实操`,
            `线上实验带练，轻松搞定ACP认证考试中的实验要求`
          ],
        },
        {
          title: '大数据ACP考纲全覆盖',
          type: 1,
          info: [
            `大数据基础与阿里云大数据平台`,
            `大数据计算服务`,
            `大数据开发与治理平台`,
            `实时计算Apache Flink`,
            `实时数据仓库`,
            `数据湖`,
            `大数据分析与可视化`
          ],
        },
        {
          title: '硬核证书 一技傍身',
          type: 2,
          img: require('../../../assets/coursePage/acp/box7/card-s.png'),
          tips: '轻松迈入大数据行业人才行列'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.box7 {
  padding: 76px 0 80px;
  background-image: url(../../../assets/coursePage/acp/box7/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;

  .content {
    margin-top: 50px;
    display: flex;
    overflow-x: auto;
    padding: 0 30px;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      width: 440px;
      min-width: 440px;
      height: 500px;
      background-color: #ffffff;
      box-shadow: 0px 10px 30px 0px #ffe5cc,
        inset 0px 2px 0px 0px #ffb266,
        inset 0px -2px 0px 0px #ffb266;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 30px 40px;
      margin-right: 30px;
      background-size: 100% 100%;

      &:nth-of-type(1) {
        background-image: url(../../../assets/coursePage/acp/box7/pic-01.png);
      }

      &:nth-of-type(2) {
        background-image: url(../../../assets/coursePage/acp/box7/pic-02.png);
      }

      &:nth-of-type(3) {
        background-image: url(../../../assets/coursePage/acp/box7/pic-03.png);
      }

      &:nth-of-type(4) {
        background-image: url(../../../assets/coursePage/acp/box7/pic-04.png);
        margin-right: 0;
      }

      .title {
        font-family: PingFangSC-Medium;
        font-size: 30px;
        line-height: 30px;
        color: #332114;
      }

      .line {
        width: 48px;
        height: 6px;
        background-color: #ff7919;
        border-radius: 3px;
        margin: 30px 0 26px;
      }

      .info-box {
        div{
          padding-left: 20px;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          line-height: 40px;
          color: #665447;
        }
        p {
          padding-left: 20px;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          line-height: 40px;
          color: #665447;
          position: relative;
          &::before{
            content: "*";
            width: 20px;
            height: 40px;
            position: absolute;
            top: 3px;
            left: 0;
            color: #665447;
          }
        }
      }

      .img-box {
        width: 100%;
        margin-top: 30px;

        .img-mask {
          width: 100%;

          .small-img {
            width: 100%;
            height: 100%;
          }
        }

        span {
          margin-top: 30px;
          display: block;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 26px;
          line-height: 26px;
          color: #332114;
        }
      }
    }
  }

  .big-img-mask{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.6);
    .check-big {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      transform: translateY(-50%);
    }
    
  }
}</style>